<template>
    <div>
        <div class="flex justify-between">
            <label class="block text-sm font-medium text-gray-700">{{ label }}
                <slot></slot>
            </label>
            <span v-if="extra" class="text-sm text-gray-500">{{extra }}</span>
        </div>
        <div class="mt-1">
            <textarea v-if="type==='area'" :disabled="disabled" :value="value" @input="$emit('input', $event.target.value)" :rows="rows?rows:3" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" :placeholder="placeholder"></textarea>
            
            <input v-else :disabled="disabled" :type="type?type:'text'" :value="value" @input="$emit('input', $event.target.value)" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" :placeholder="placeholder">

            
        </div>
    </div>
</template>

<script>
export default {
  name: "TextField",
    props: ['label', 'extra', 'value', 'placeholder', 'type', 'rows', 'disabled']
}
</script>

<style scoped>

</style>
